<div class="flex w-full h-full justify-between gap-2">
  @for (step of store.createTaSteps(); track step;  let ii = $index) {
    @if (ii == store.createTaSteps().indexOf(store.currentCreateTaStep())) {
      <timeline-step [step]="step" [currentlySelected]="true" [index]="ii" (stepClicked)="setStep(step)"></timeline-step>
    } @else {
      <timeline-step [step]="step" [currentlySelected]="false" [index]="ii" (stepClicked)="setStep(step)"></timeline-step>
    }
    @if (ii < store.createTaSteps().length - 1) {
      <div class="flex-1 flex items-center">
        @if (ii ==  store.createTaSteps().indexOf(store.currentCreateTaStep())) {
          <div class="w-full h-[2px] bg-primary"></div>
        } @else {
          <div class="w-full h-[2px] bg-surface-300"></div>
        }
      </div>
    }
  }
</div>


